export var RegionKey;
(function (RegionKey) {
    RegionKey["Harju"] = "harju";
    RegionKey["Hiiu"] = "hiiu";
    RegionKey["IdaViru"] = "ida_viru";
    RegionKey["Jogeva"] = "jogeva";
    RegionKey["Jarva"] = "jarva";
    RegionKey["Laane"] = "laane";
    RegionKey["LaaneViru"] = "laane_viru";
    RegionKey["Polva"] = "polva";
    RegionKey["Parnu"] = "parnu";
    RegionKey["Rapla"] = "rapla";
    RegionKey["Saare"] = "saare";
    RegionKey["Tartu"] = "tartu";
    RegionKey["Valga"] = "valga";
    RegionKey["Viljandi"] = "viljandi";
    RegionKey["Voru"] = "voru";
})(RegionKey || (RegionKey = {}));
